<template>
  <div>
    <el-breadcrumb separator-icon="ArrowRight" style="margin: 16px">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>申请调宿</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- PC端 -->
    <el-card v-if="!isMobile" style="margin: 15px; min-height: calc(100vh - 111px)">
      <div style="margin: 10px 0">
        <div style="display: flex; align-items: center;">
          <el-input v-model="search" clearable placeholder="请输入姓名" prefix-icon="Search" style="width: 200px"/>
          <el-button icon="Search" style="margin-left: 5px" type="primary" @click="load"/>
          <div style="margin-left: auto;">
            <el-button icon="plus" type="primary" @click="add">申请调宿</el-button>
          </div>
        </div>
      </div>
      <el-table v-loading="loading" :data="tableData" border max-height="705" style="width: 100%">
        <el-table-column label="#" type="index" width="50"/>
        <el-table-column label="姓名" prop="name" min-width="80"/>
        <el-table-column label="当前宿舍" min-width="120">
          <template #default="scope">
            {{ formatRoomLabel(scope.row.oldDormBuildId, scope.row.oldDormRoomId) }}
          </template>
        </el-table-column>
        <el-table-column label="调宿类型" min-width="110">
          <template #default="scope">
            <el-tag :type="getReasonTypeTag(scope.row.reasonType)" size="small">{{ scope.row.reasonType || '房间设施问题' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="期望房型" min-width="120">
          <template #default="scope">
            <span>{{ scope.row.targetRoomType || '-' }}</span>
            <el-tag v-if="isCrossType(scope.row)" type="danger" size="small" style="margin-left:4px">需审批</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="分配宿舍" min-width="120">
          <template #default="scope">
            <span v-if="scope.row.newDormRoomId">{{ scope.row.newDormRoomId }}</span>
            <span v-else style="color:#909399">待分配</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="100">
          <template #default="scope">
            <el-tag :type="getStateTagType(scope.row.state)" disable-transitions>{{ scope.row.state }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" prop="applyTime" min-width="140" sortable/>
        <el-table-column label="操作" width="74px" fixed="right">
          <template #default="scope">
            <el-button icon="more-filled" type="default" @click="showDetail(scope.row)"/>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 10px 0">
        <el-pagination v-model:currentPage="currentPage" :page-size="pageSize" :page-sizes="[10, 20]" :total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
      </div>

      <!-- PC端新增弹窗 -->
      <el-dialog v-model="dialogVisible" title="申请调宿" width="560px" @close="cancel">
        <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="姓名">
            <el-input :model-value="form.name" disabled/>
          </el-form-item>
          <el-form-item label="当前宿舍">
            <el-input :model-value="formatRoomLabel(form.oldDormBuildId, form.oldDormRoomId)" disabled/>
          </el-form-item>
          <el-form-item label="当前房型">
            <el-input :model-value="currentRoomTypeLabel" disabled/>
          </el-form-item>
          <el-form-item label="调宿类型" prop="reasonType">
            <el-radio-group v-model="form.reasonType">
              <el-radio label="单独住宿">单独住宿</el-radio>
              <el-radio label="环境问题">环境问题</el-radio>
              <el-radio label="房间设施问题">房间设施问题</el-radio>
            </el-radio-group>
            <div class="reason-type-tip">
              <span v-if="form.reasonType === '单独住宿'" class="tip-warn">需要学校审批</span>
              <span v-else-if="form.reasonType === '环境问题'" class="tip-warn">原则上需要学校审批</span>
              <span v-else-if="form.reasonType === '房间设施问题'" class="tip-info">宿管可直接处理</span>
            </div>
          </el-form-item>
          <el-form-item label="期望房型" prop="targetRoomType">
            <el-radio-group v-model="form.targetRoomType">
              <el-radio label="小房间">小房间（1-4栋，15㎡，无阳台）</el-radio>
              <el-radio label="大房间">大房间（5-6栋，25㎡，有阳台）</el-radio>
            </el-radio-group>
            <div v-if="isCrossTypeForm" class="reason-type-tip">
              <span class="tip-warn">当前住小房间，换大房间需学校审批</span>
            </div>
          </el-form-item>
          <el-form-item label="申请理由" prop="reason">
            <el-input v-model="form.reason" :autosize="{ minRows: 3, maxRows: 8 }" type="textarea" clearable placeholder="请详细说明调宿原因"/>
          </el-form-item>
          <div class="form-notice">
            <el-icon><InfoFilled/></el-icon>
            <span>具体房间由管理员根据住宿情况统一分配，提交后请等待处理</span>
          </div>
        </el-form>
        <template #footer>
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="save">提交申请</el-button>
        </template>
      </el-dialog>

      <!-- PC端详情弹窗 -->
      <el-dialog v-model="detailDialog" title="调宿详情" width="500px">
        <el-descriptions :column="1" border>
          <el-descriptions-item label="姓名">{{ detail.name }}</el-descriptions-item>
          <el-descriptions-item label="当前宿舍">{{ formatRoomLabel(detail.oldDormBuildId, detail.oldDormRoomId) }}</el-descriptions-item>
          <el-descriptions-item label="当前房型">{{ detail.currentRoomType || '-' }}</el-descriptions-item>
          <el-descriptions-item label="调宿类型">
            <el-tag :type="getReasonTypeTag(detail.reasonType)" size="small">{{ detail.reasonType || '房间设施问题' }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="期望房型">
            {{ detail.targetRoomType || '-' }}
            <el-tag v-if="isCrossType(detail)" type="danger" size="small" style="margin-left:4px">需审批</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="分配宿舍">
            <span v-if="detail.newDormRoomId" style="color:#409eff;font-weight:500">{{ detail.newDormRoomId }}</span>
            <span v-else style="color:#909399">待分配</span>
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="getStateTagType(detail.state)">{{ detail.state }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="申请时间">{{ detail.applyTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="处理时间">{{ detail.processTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="申请理由">
            <div v-html="detail.reason || '-'"></div>
          </el-descriptions-item>
        </el-descriptions>
        <template #footer>
          <el-button type="primary" @click="closeDetails">确定</el-button>
        </template>
      </el-dialog>
    </el-card>

    <!-- 手机端 -->
    <div v-else class="mobile-container">
      <!-- 顶部操作栏 -->
      <div class="mobile-top-bar">
        <el-input v-model="search" clearable placeholder="搜索姓名" prefix-icon="Search" class="mobile-search"/>
        <el-button icon="Search" type="primary" @click="load"/>
        <el-button icon="plus" type="primary" @click="add"/>
      </div>

      <!-- 调宿列表 -->
      <div v-loading="loading" class="mobile-list">
        <div v-if="!loading && tableData.length === 0" class="mobile-empty">暂无调宿申请</div>
        <div v-for="(item, idx) in tableData" :key="idx" class="mobile-card" @click="showDetail(item)">
          <div class="mobile-card-header">
            <span class="mobile-card-title">{{ item.name || '-' }}</span>
            <el-tag size="small" :type="getStateTagType(item.state)">{{ item.state }}</el-tag>
          </div>
          <div class="mobile-card-body">
            <div class="mobile-card-row">
              <span class="mobile-card-label">当前宿舍</span>
              <span class="mobile-card-value">{{ formatRoomLabel(item.oldDormBuildId, item.oldDormRoomId) }}</span>
            </div>
            <div class="mobile-card-row">
              <span class="mobile-card-label">调宿类型</span>
              <el-tag size="small" :type="getReasonTypeTag(item.reasonType)">{{ item.reasonType || '房间设施问题' }}</el-tag>
            </div>
            <div class="mobile-card-row">
              <span class="mobile-card-label">期望房型</span>
              <span class="mobile-card-value">
                {{ item.targetRoomType || '-' }}
                <el-tag v-if="isCrossType(item)" type="danger" size="small" style="margin-left:4px">需审批</el-tag>
              </span>
            </div>
            <div class="mobile-card-row">
              <span class="mobile-card-label">分配宿舍</span>
              <span v-if="item.newDormRoomId" class="mobile-card-value highlight">{{ item.newDormRoomId }}</span>
              <span v-else class="mobile-card-value" style="color:#909399">待分配</span>
            </div>
            <div class="mobile-card-row">
              <span class="mobile-card-label">申请时间</span>
              <span class="mobile-card-value">{{ item.applyTime || '-' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 手机端分页 -->
      <div v-if="total > 0" class="mobile-pagination">
        <el-pagination v-model:currentPage="currentPage" :page-size="pageSize" :total="total" layout="prev, pager, next" @current-change="handleCurrentChange"/>
      </div>

      <!-- 手机端新增表单 -->
      <el-dialog v-model="dialogVisible" title="申请调宿" width="92%" :fullscreen="true" @close="cancel">
        <div class="mobile-form-container">
          <div class="mobile-form-section">
            <div class="mobile-form-section-title">当前信息</div>
            <div class="mobile-info-block">
              <div class="mobile-info-row">
                <span class="mobile-info-label">姓名</span>
                <span class="mobile-info-value">{{ form.name || '-' }}</span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">当前宿舍</span>
                <span class="mobile-info-value">{{ formatRoomLabel(form.oldDormBuildId, form.oldDormRoomId) }}</span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">当前房型</span>
                <span class="mobile-info-value">{{ currentRoomTypeLabel }}</span>
              </div>
            </div>
          </div>
          <div class="mobile-form-section">
            <div class="mobile-form-section-title">申请信息</div>
            <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
              <el-form-item label="调宿类型" prop="reasonType">
                <el-radio-group v-model="form.reasonType" class="mobile-radio-group">
                  <el-radio label="单独住宿">
                    <span>单独住宿</span>
                    <div class="radio-tip warn">需学校审批</div>
                  </el-radio>
                  <el-radio label="环境问题">
                    <span>环境问题</span>
                    <div class="radio-tip warn">原则上需学校审批</div>
                  </el-radio>
                  <el-radio label="房间设施问题">
                    <span>房间设施问题</span>
                    <div class="radio-tip info">宿管可直接处理</div>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="期望房型" prop="targetRoomType">
                <el-radio-group v-model="form.targetRoomType" class="mobile-radio-group">
                  <el-radio label="小房间">
                    <span>小房间</span>
                    <div class="radio-sub">1-4栋，15㎡，无阳台</div>
                  </el-radio>
                  <el-radio label="大房间">
                    <span>大房间</span>
                    <div class="radio-sub">5-6栋，25㎡，有阳台</div>
                  </el-radio>
                </el-radio-group>
                <div v-if="isCrossTypeForm" class="cross-type-warn">
                  <el-icon><WarningFilled/></el-icon>
                  <span>当前住小房间，换大房间需学校审批</span>
                </div>
              </el-form-item>
              <el-form-item label="申请理由" prop="reason">
                <el-input v-model="form.reason" :autosize="{ minRows: 4, maxRows: 10 }" type="textarea" clearable placeholder="请详细说明调宿原因"/>
              </el-form-item>
            </el-form>
            <div class="mobile-form-notice">
              <el-icon><InfoFilled/></el-icon>
              <span>具体房间由管理员根据住宿情况统一分配，提交后请等待处理</span>
            </div>
          </div>
        </div>
        <template #footer>
          <div class="mobile-form-footer">
            <el-button @click="cancel" style="flex:1">取消</el-button>
            <el-button type="primary" @click="save" style="flex:1">提交申请</el-button>
          </div>
        </template>
      </el-dialog>

      <!-- 手机端详情弹窗 -->
      <el-dialog v-model="detailDialog" title="调宿详情" width="92%" :fullscreen="true">
        <div class="mobile-form-container">
          <div class="mobile-form-section">
            <div class="mobile-form-section-title">基本信息</div>
            <div class="mobile-info-block">
              <div class="mobile-info-row">
                <span class="mobile-info-label">姓名</span>
                <span class="mobile-info-value">{{ detail.name || '-' }}</span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">当前宿舍</span>
                <span class="mobile-info-value">{{ formatRoomLabel(detail.oldDormBuildId, detail.oldDormRoomId) }}</span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">当前房型</span>
                <span class="mobile-info-value">{{ detail.currentRoomType || '-' }}</span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">调宿类型</span>
                <el-tag size="small" :type="getReasonTypeTag(detail.reasonType)">{{ detail.reasonType || '房间设施问题' }}</el-tag>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">期望房型</span>
                <span class="mobile-info-value">
                  {{ detail.targetRoomType || '-' }}
                  <el-tag v-if="isCrossType(detail)" type="danger" size="small" style="margin-left:4px">需审批</el-tag>
                </span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">分配宿舍</span>
                <span v-if="detail.newDormRoomId" class="mobile-info-value highlight">{{ detail.newDormRoomId }}</span>
                <span v-else class="mobile-info-value" style="color:#909399">待分配</span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">状态</span>
                <el-tag size="small" :type="getStateTagType(detail.state)">{{ detail.state }}</el-tag>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">申请时间</span>
                <span class="mobile-info-value">{{ detail.applyTime || '-' }}</span>
              </div>
              <div class="mobile-info-row">
                <span class="mobile-info-label">处理时间</span>
                <span class="mobile-info-value">{{ detail.processTime || '-' }}</span>
              </div>
            </div>
          </div>
          <div class="mobile-form-section">
            <div class="mobile-form-section-title">申请理由</div>
            <div class="mobile-content-block" v-html="detail.reason || '-'"></div>
          </div>
        </div>
        <template #footer>
          <el-button type="primary" @click="closeDetails" style="width:100%">确定</el-button>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script src="@/assets/js/ApplyChangeRoom.js"></script>
<style scoped>
/* === PC端样式 === */
.reason-type-tip { margin-top: 6px; font-size: 12px; }
.tip-warn { color: #E6A23C; }
.tip-info { color: #67C23A; }
.form-notice { display: flex; align-items: center; gap: 6px; padding: 10px 12px; background: #f5f7fa; border-radius: 6px; color: #909399; font-size: 13px; margin-top: 8px; }
.cross-type-warn { display: flex; align-items: center; gap: 6px; padding: 8px 12px; background: #fdf6ec; border-radius: 6px; color: #E6A23C; font-size: 13px; margin-top: 8px; }

/* === 手机端样式 === */
.mobile-container { padding: 12px; }
.mobile-top-bar { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; }
.mobile-search { flex: 1; }
.mobile-list { min-height: 200px; }
.mobile-empty { text-align: center; color: #999; padding: 40px 0; font-size: 14px; }
.mobile-card { background: #fff; border-radius: 10px; padding: 14px; margin-bottom: 10px; box-shadow: 0 1px 4px rgba(0,0,0,0.06); }
.mobile-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
.mobile-card-title { font-size: 15px; font-weight: 600; color: #303133; }
.mobile-card-row { display: flex; justify-content: space-between; align-items: center; padding: 4px 0; }
.mobile-card-label { color: #909399; font-size: 13px; }
.mobile-card-value { color: #606266; font-size: 13px; }
.mobile-card-value.highlight { color: #409eff; font-weight: 500; }
.mobile-pagination { display: flex; justify-content: center; margin-top: 12px; }

/* 手机端表单 */
.mobile-form-container { }
.mobile-form-section { background: #fff; border-radius: 10px; padding: 16px; margin-bottom: 12px; }
.mobile-form-section-title { font-size: 15px; font-weight: 600; color: #303133; margin-bottom: 12px; padding-left: 10px; border-left: 3px solid #409eff; }
.mobile-info-block { }
.mobile-info-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 0; border-bottom: 1px solid #f2f3f5; }
.mobile-info-row:last-child { border-bottom: none; }
.mobile-info-label { color: #909399; font-size: 14px; }
.mobile-info-value { color: #303133; font-size: 14px; font-weight: 500; }
.mobile-info-value.highlight { color: #409eff; }
.mobile-content-block { padding: 10px; background: #f5f7fa; border-radius: 8px; font-size: 14px; color: #303133; line-height: 1.6; }
.mobile-form-footer { display: flex; gap: 12px; }
.mobile-radio-group { display: flex; flex-direction: column; gap: 12px; }
.mobile-radio-group .el-radio { display: flex; align-items: flex-start; height: auto; }
.radio-tip { font-size: 12px; margin-top: 2px; }
.radio-tip.warn { color: #E6A23C; }
.radio-tip.info { color: #67C23A; }
.radio-sub { font-size: 12px; color: #909399; margin-top: 2px; }
.mobile-form-notice { display: flex; align-items: center; gap: 6px; padding: 10px 12px; background: #f5f7fa; border-radius: 6px; color: #909399; font-size: 13px; margin-top: 8px; }
</style>
